export default "__VITE_ASSET__4e2297d6__"